<template>
  <div class="feature-box" :class="{ 'bottom' : isBottom, 'no-data': isBottom && isNoData }">
    <div class="feature-box-item">
      <v-btn
        v-for="(button, index) in headerButtons.filter(button => !button.isRight)"
        :key="index"
        outline
        class="UXbtn header-btn left-btn"
        :class="{ 'feature-delete-btn': button.isDelete }"
        @click="()=>{ buttonEvent(button) }"
        :disabled="button.isDisabled"
      >
        {{ button.text }}
      </v-btn>
    </div>
    <div class="feature-box-item">
      <v-btn
        v-for="(button, index) in headerButtons.filter(button => button.isRight)"
        :key="index"
        outline
        class="UXbtn header-btn"
        @click="()=>{ buttonEvent(button) }"
        :disabled="button.isDisabled"
      >
        {{ button.text }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tableTopButtons',
  props: {
    headerButtons: {
      type: Array,
      default: () => [],
      required: false
    },
    isBottom: {
      type: Boolean,
      default: false,
      required: false
    },
    buttonEvent: {
      type: Function,
      default: () => {},
      required: false
    },
    isNoData: {
      type: Boolean,
      default: false,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/menus/customer/components/tableTopButtons.vue